import { render, staticRenderFns } from "./UserEditProfil.vue?vue&type=template&id=af6ccdb2&"
import script from "./UserEditProfil.vue?vue&type=script&lang=ts&"
export * from "./UserEditProfil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports